import { Activity, MeetupsTableItemType, Section, SectionType } from "../../../../types";
import schedule from "../../../../assets/svg/schedule-gray.svg";
import clock from "../../../../assets/svg/clock.svg";
import { useGlobalMiscState } from "../../../../stores/misc";
import { getDateOnly, getHHMMFromDateString } from "../../../../misc/utils";
import { Parser } from "html-to-react";

export default function MeetupsDescrCard() {
  const miscState = useGlobalMiscState();
  const currentMeet: Activity = miscState.get('meetupsFormEditItem');

  if (!currentMeet) {
    return null;
  }

  return (
    <div className="py-4 md:py-[39px] text-black flex justify-center w-full">
      <div className="border-[#F0F3FA] border-4 md:border-8 rounded-[10px] md:rounded-[20px] w-full max-w-md lg:max-w-lg">
        <img src={currentMeet.main_image} alt="img" className="rounded-t-lg w-full" />
        <div
          className="p-3 md:p-4 overflow-x-auto max-h-[50vh] md:h-[40vh] [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar]:h-[30px] 
            [&::-webkit-scrollbar-track]:rounded-full
            [&::-webkit-scrollbar-track]:bg-gray-100
            [&::-webkit-scrollbar-thumb]:rounded-full
            [&::-webkit-scrollbar-thumb]:bg-gray-300
            dark:[&::-webkit-scrollbar-track]:bg-transparent
            dark:[&::-webkit-scrollbar-thumb]:bg-[#E4E8F2] "
        >
          <div className="flex gap-2">
            <p className="bg-[#F0F3FA] rounded-lg py-[2px] px-[6px] text-[11px] font-normal">
              {currentMeet.department?.title}
            </p>
            <p className="bg-[#F0F3FA] rounded-lg py-[2px] px-[6px] text-[11px] font-normal">
              {currentMeet.category?.name}
            </p>
          </div>

          <div className="flex gap-2 mt-[10px] items-center">
            <p className="text-sm font-normal text-[#5F6B88] flex items-center gap-1">
              <img src={schedule} alt="schedule" />
              {getDateOnly(currentMeet.createdAt)}
            </p>
            <p className="text-sm font-normal text-[#5F6B88] flex items-center gap-1">
              <img src={clock} alt="clock" />
              {getHHMMFromDateString(currentMeet.createdAt)}
            </p>
          </div>

          <p className="font-semibold text-lg md:text-[24px] mt-2">{currentMeet.name}</p>

          <div className="mt-3 font-normal text-sm ">
            {Parser().parse(currentMeet.description)}
          </div>
        </div>
      </div>
    </div>
  );
}
